import { IGif } from '@giphy/js-types'
import { GifOverlayProps } from '@giphy/react-components'
import React, { createContext, ReactType, SyntheticEvent, useContext } from 'react'
import { useKeyPress } from 'react-use'
import GifMenuOverlay from './gif-menu-overlay'
import GifSelectionOverlay from './gif-selector-overaly'
import TagOverlay from './tag-overlay'

type GridOverlayContextProps = {
    onGifClick: (gif: IGif, e: SyntheticEvent<HTMLElement, Event>) => void
    selectedGifs: (number | string)[]
    iSelectionMode: boolean
    Overlay?: ReactType<GifOverlayProps>
}
export const GridOverlayContext = createContext({} as GridOverlayContextProps)

const GridOverlay = ({ gif, isHovered }: GifOverlayProps) => {
    const { onGifClick, selectedGifs, iSelectionMode, Overlay } = useContext(GridOverlayContext)
    const [isDetailMode] = useKeyPress((event: KeyboardEvent) => event.keyCode === 18)
    return iSelectionMode ? (
        <GifSelectionOverlay
            gif={gif}
            index={selectedGifs.indexOf(gif.id)}
            onClick={onGifClick}
            showDetails={isDetailMode}
        />
    ) : Overlay ? (
        <>
            <Overlay gif={gif} isHovered={isHovered} />
            <GifMenuOverlay gif={gif} isHovered={isHovered} />
            <TagOverlay gif={gif} isHovered={isHovered} />
        </>
    ) : (
        <>
            <GifMenuOverlay gif={gif} isHovered={isHovered} />
            <TagOverlay gif={gif} isHovered={isHovered} />
        </>
    )
}

export default GridOverlay
